import React from 'react';
import Button from '../../Shared/UI/Button/components/Button';

import {
  useRestrictedActionShowState,
  useRestrictedActionShowActions
} from './RestrictedActionShowContext';
import RestrictedActionShowLoader from './RestrictedActionShowLoader';
import RestrictedActionEditModal from './RestrictedActionEditModal';
import DeleteRestrictedActionModal from './DeleteRestrictedActionModal';
import AddRoleModal from './AddRoleModal';
import AddUserModal from './AddUserModal';

import {
  removeRoleFromRestrictedAction,
  removeUserFromRestrictedAction,
} from './restApi';

import styles from './Show.module.scss';

const RestrictedActionShowContent = ({ restrictedAction }) => {
  const state = useRestrictedActionShowState();
  const { onResponse, onError, openRestrictedActionEditModal, openDeleteRestrictedActionModal, openAddRoleModal, openAddUserModal } = useRestrictedActionShowActions();

  const authenticityToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");

  const goToRestrictedActionsIndex = () => {
    location.assign(`/restricted_actions/`);
  };

  const goToRole = (role) => {
    location.assign(`/roles/${role.id}`);
  };

  const goToUser = (user) => {
    location.assign(`/users/${user.id}`);
  };

  return (
    <>
      <section className={styles.section}>
        <Button
          variant="primary"
          onClick={() => goToRestrictedActionsIndex()}
        >
          View All Restricted Actions
        </Button>
      </section>
      <section className={styles.section}>
        <h2 className={styles.tableTitle}>
          Restricted Action
        </h2>
        {state?.restrictedAction && (
          <table>
            <thead>
              <tr>
                <th>Group Id</th>
                <th>Restricted Action Name</th>
                <th>Resource Id</th>
                <th>Resource Type</th>
                <th>Apply To All Users</th>
              </tr>
            </thead>
            <tbody>
              <tr key={state?.restrictedAction.id}>
                <td>{state?.restrictedAction.groupId}</td>
                <td>{state?.restrictedAction.restrictedActionName}</td>
                <td>{state?.restrictedAction.resourceId}</td>
                <td>{state?.restrictedAction.resourceType}</td>
                <td>{state?.restrictedAction.applyToAllUsers.toString()}</td>
                <td>
                  <Button
                    variant="primary"
                    onClick={(e) => {
                      e.preventDefault();
                      openRestrictedActionEditModal();
                    }}
                  >
                    Edit
                  </Button>
                </td>
              </tr>
            </tbody>
          </table>
        )}
      </section>
      <section className={styles.section}>
        <h2 className={styles.tableTitle}>
          Roles
        </h2>
        <Button
          variant="primary"
          onClick={() => openAddRoleModal()}
        >
          Add Role
        </Button>
        {state?.restrictedAction?.roles?.length ? (
          <table>
            <thead>
              <tr>
                <th>Group Id</th>
                <th>Role Name</th>
              </tr>
            </thead>
            <tbody>
              {state?.restrictedAction?.roles?.map(role => {
                return (
                  <tr key={role.id}>
                    <td>{role.groupId}</td>
                    <td>{role.roleName}</td>
                    <td>
                      <Button
                        variant="primary"
                        onClick={() => goToRole(role)}
                      >
                        View Details
                      </Button>
                    </td>
                    <td>
                      <Button
                        variant="destructive"
                        onClick={() => {
                          removeRoleFromRestrictedAction({
                            restrictedAction,
                            onResponse,
                            onError,
                            body: {
                              role,
                              authenticity_token: authenticityToken,
                            },
                          });
                        }}
                      >
                        Remove Role
                      </Button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        ) : (
          <p className={styles.noContentMessage}>No roles for this restricted action.</p>
        )}
      </section>
      <section className={styles.section}>
        <h2 className={styles.tableTitle}>
          Users
        </h2>
        <Button
          variant="primary"
          onClick={() => openAddUserModal()}
        >
          Add User
        </Button>
        {state?.restrictedAction?.users?.length ? (
          <table>
            <thead>
              <tr>
                <th>First Name</th>
                <th>Last Name</th>
              </tr>
            </thead>
            <tbody>
              {state?.restrictedAction?.users?.map(user => {
                return (
                  <tr key={user.id}>
                    <td>{user.firstName}</td>
                    <td>{user.lastName}</td>
                    <td>
                      <Button
                        variant="primary"
                        onClick={() => goToUser(user)}
                      >
                        View Details
                      </Button>
                    </td>
                    <td>
                      <Button
                        variant="destructive"
                        onClick={() => {
                          removeUserFromRestrictedAction({
                            restrictedAction,
                            onResponse,
                            onError,
                            body: {
                              user,
                              authenticity_token: authenticityToken,
                            },
                          });
                        }}
                      >
                        Remove User
                      </Button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        ) : (
          <p className={styles.noContentMessage}>No users with this restricted action.</p>
        )}
      </section>
      <section className={styles.section}>
        <div className={styles.dangerZone}>
          <h3 className={styles.dangerZoneTitle}>Danger Zone</h3>
          <div className={styles.dangerZoneAction}>
            <div>
              <strong>Delete this restricted action</strong>
              <p>Once deleted, all associated role and user grants will be permanently removed.</p>
            </div>
            <Button
              variant="destructive"
              onClick={() => openDeleteRestrictedActionModal()}
            >
              Delete Restricted Action
            </Button>
          </div>
        </div>
      </section>
    </>
  );
};

const Show = ({ restrictedAction }) => {
  return (
    <>
      <RestrictedActionShowLoader restrictedAction={restrictedAction} />
      <RestrictedActionShowContent restrictedAction={restrictedAction} />
      <RestrictedActionEditModal />
      <DeleteRestrictedActionModal />
      <AddRoleModal restrictedAction={restrictedAction} />
      <AddUserModal restrictedAction={restrictedAction} />
    </>
  );
};

export default Show;
